import StorageHelper from 'Stores/helper';

const scope = 'CAMPAIGNS/navigation';

const defaultState = {
    actionDetails: {},
    activeAction: 'email',
    activeStep: 'welcome',
    activeStepNumber: 1,
    totalStepNumber: 1,
    enabledActions: [],
    completedAllActions: false,
    campaignRestrictionsError: false,
    allActionsAlreadyTaken: false
};

const mod = {
    namespaced: true,
    state: {
      actionCompleted: '',
      actionDetails: {},
      activeAction: '',
      activeStep: '',
      activeStepNumber: 1,
      campaignDescriptionVisible: true,
      totalStepNumber: 1,
      actionLoading: false,
      allActionsAlreadyTaken: false,
      campaignRestrictionsError: false,
      completedAllActions: false,
      currentActionStep: null,
      modalOpen: false,
      stepModalOpen: ""
    },
    mutations: {
      actionCompleted: (state, actionCompleted) => {
        state.actionCompleted = actionCompleted;
      },
      actionDetails: (state, actionDetailsObject) => {
        state.actionDetails = { ...state.actionDetails, ...actionDetailsObject };
      },
      activeAction: (state, action) => {
        state.activeAction = action.toLowerCase();
      },
      activeStep: (state, step) => {
        state.activeStep = step ? step.toLowerCase() : null;
      },
      activeStepNumber: (state, num) => {
        state.activeStepNumber = num;
      },
      totalStepNumber: (state, num) => {
        state.totalStepNumber = num;
      },
      actionLoading: (state, loading) => {
        state.actionLoading = loading;
      },
      campaignDescriptionVisible: (state, bool) => {
        state.campaignDescriptionVisible = bool;
      },
      enabledActions: (state, actions) => {
        state.enabledActions = actions;
      },
      completedAllActions: (state) => {
        state.completedAllActions = true;
      },
      campaignRestrictionsError: (state, set) => {
        state.campaignRestrictionsError = set;
      },
      allActionsAlreadyTaken: (state, actions) => {
        state.allActionsAlreadyTaken = actions;
      },
      currentActionStep(state, step) {
        state.currentActionStep = typeof(step) === 'string' ? step.toLowerCase() : step;
      },
      incrementActiveStepNumber: (state) => {
        state.activeStepNumber += 1;
      },
      modalOpen: (state, bool) => {
        state.modalOpen = bool
      },
      stepModalOpen: (state, modal) => {
        state.stepModalOpen = modal.toLowerCase();
      }
    },
    actions: {
      actionCompleted({ commit }, action) {
        StorageHelper.setLocalStorageVar(commit, action, 'actionCompleted', scope);
      },
      actionDetails({ commit }, action) {
        StorageHelper.setLocalStorageVar(commit, action, 'actionDetails', scope);
      },
      activeAction({ commit }, action) {
        StorageHelper.setLocalStorageVar(commit, action, 'activeAction', scope);
      },
      activeStep({ commit }, action) {
        StorageHelper.setLocalStorageVar(commit, action, 'activeStep', scope);
      },
      activeStepNumber({ commit }, num) {
        commit("activeStepNumber", num);
      },
      totalStepNumber({ commit }, num) {
        commit("totalStepNumber", num);
      },
      actionLoading({ commit }, action) {
        StorageHelper.setLocalStorageVar(commit, action, 'actionLoading', scope);
      },
      enabledActions({ commit }, actions) {
        StorageHelper.setLocalStorageVar(commit, actions, 'enabledActions', scope);
      },
      allActionsAlreadyTaken({ commit }, actions) {
        StorageHelper.setLocalStorageVar(commit, actions, 'allActionsAlreadyTaken', scope);
      },
      campaignDescriptionVisible({ commit }, bool) {
        commit("campaignDescriptionVisible", bool)
      },
      currentActionStep({ commit }, step) {
        commit("currentActionStep", step);
      },
      incrementActiveStepNumber({ commit }, num) {
        commit("incrementActiveStepNumber", num);
      },
      modalOpen({ commit }, action) {
        StorageHelper.setLocalStorageVar(commit, action, 'modalOpen', scope);
      },
      stepModalOpen({ commit }, modal = "") {
        commit("stepModalOpen", modal);
      },
      completedAllActions({ commit }) {
        commit('completedAllActions');
      },
      campaignRestrictionsError({ commit }, set = true) {
        commit('campaignRestrictionsError', set);
      },
    },
    getters: {
      actionCompleted(state) {
        return state.actionCompleted;
      },
      actionDetails(state) {
        return state.actionDetails;
      },
      activeAction(state) {
        return state.activeAction;
      },
      activeStep(state) {
        return state.activeStep;
      },
      activeStepNumber(state) {
        return state.activeStepNumber;
      },
      campaignDescriptionVisible(state) {
        return state.campaignDescriptionVisible;
      },
      totalStepNumber(state) {
        return state.totalStepNumber;
      },
      actionLoading(state) {
        return state.actionLoading;
      },
      enabledActions(state) {
        return state.enabledActions;
      },
      completedAllActions(state) {
        return state.completedAllActions;
      },
      campaignRestrictionsError(state) {
        return state.campaignRestrictionsError;
      },
      allActionsAlreadyTaken(state) {
        return state.allActionsAlreadyTaken;
      },
      currentActionStep({ currentActionStep }) {
        return currentActionStep;
      },
      modalOpen(state) {
        return state.modalOpen
      },
      stepModalOpen(state) {
        return state.stepModalOpen;
      }
    },
};

export default mod;
